import { LABEL_VALUE, LOGIN_VALUE } from "./StoreValueType";

const initialState = {
  loginValues: [],
  labelValues: [],
};

const valueReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_VALUE:
      return {
        ...state,
        loginValues: [action.payload],
      };
    case LABEL_VALUE:
      return {
        ...state,
        labelValues: [action.payload],
      };
    default:
      return state;
  }
};

export default valueReducer;
